import { Snackbar, Alert, Button, IconButton } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CloseIcon from '@mui/icons-material/Close';
import UserContext from "../../contexts/UserContext";
import { useFetchMostRecentSession } from "../../services/sessions_service";

export default function RecentSessionAlert() {
    const { user } = useContext(UserContext);
    const { isLoading, session } = useFetchMostRecentSession(user?.id); // upcoming sessions
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleClose = () => {
        setOpen(false);
    }

    const handleClick = () => {
        setOpen(false);
        navigate(`/dashboard/chats/${session?.chatId}`);
    }

    useEffect(() => {
        if (session) {
            setOpen(true);
        }
    }, [session]);

    
    if (isLoading) {
        return null;
    }

    const { name, sessionDate, sessionTime } = session || {};
    const dateTime = dayjs.utc(`${sessionDate} ${sessionTime}`).local().fromNow();
    return (
        <Snackbar open={open} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        ClickAwayListenerProps={{
            mouseEvent: false,
            touchEvent: false,
        }}
        >
            <Alert
                onClose={handleClose}
                severity="info"
                sx={{ width: '100%' }}
                action={
                    <>
                        <Button color="secondary" size="small" onClick={handleClick}>
                            {t('Open')}
                        </Button>
                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={handleClose}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </>
                }
            >
                {
                    t('upcoming_session_alert', {
                        name,
                        time: dateTime
                    })
                }
            </Alert>
        </Snackbar>
    )
}
